import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AwardPhotos from "./AwardPhotos";

const Awards = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);
  return (
    <div className="w-full px-3 md:px-7 lg:px-10 lg:py-6 py-4 md:py-8 ">
      <h1
        className="text-center text-3xl md:text-4xl lg:text-5xl font-semibold tracking-wide dmsans"
        data-aos="fade-up"
      >
        "Awards & Achievement Gallery"
      </h1>
      <p
        className="text-lg md:text-xl text-center mt-4 px-4 sm:px-10 lg:px-[200px] text-[#55586F] tracking-wide leading-normal heebo"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        "Showcasing a collection of prestigious awards and significant
        achievements that reflect dedication, excellence, and success."
      </p>
      <AwardPhotos />
    </div>
  );
};

export default Awards;
